import { useResponsiveMobile } from "../../../hooks/useResponsiveMobile";
import { CheckRow, MobileCard2 } from "./Section1";

export const Sales = ({
  refs,
}: {
  refs: {
    payment: React.RefObject<HTMLDivElement>;
    payService: React.RefObject<HTMLDivElement>;
    settle: React.RefObject<HTMLDivElement>;
    merchant: React.RefObject<HTMLDivElement>;
    sales: React.RefObject<HTMLDivElement>;
  };
}) => {
  const isMobile = useResponsiveMobile(900);
  const isBr = useResponsiveMobile(600);
  return (
    <div
      id="sales-network"
      className="flex flex-col gap-[80px] md:gap-[100px] overflow-y-hidden"
      ref={refs.sales}
    >
      <div className="flex flex-col gap-[80px] md:gap-14">
        {/* 영업대행 관리 서비스 소개글 */}
        <div className="flex flex-col gap-[32px] md:gap-10">
          <div className="flex flex-col gap-[12px]">
            <h1 className="font-bold text-[36px] md:text-display flex items-center gap-[4px]">
              {isMobile && (
                <img
                  width="48"
                  height="48"
                  alt="영업대행 관리 서비스"
                  src="/assets/images/icon/sidenav_sale.png"
                />
              )}
              영업대행 관리 서비스
            </h1>
            <span className="text-[18px] md:text-[20px] font-semibold text-[#0079FF]">
              {isMobile ? (
                <>
                  {" "}
                  작은 조직도, 규모와 상관없이 <br /> 영업을 더 스마트하게
                </>
              ) : (
                <> 작은 조직도, 규모와 상관없이 영업을 더 스마트하게</>
              )}
            </span>
          </div>

          <span className="text-[16px] md:text-[18px] text-[#4D4F58] font-normal leading-relaxed">
            {isMobile ? (
              <>
                총판, 대리점, 딜러 등 다양한 영업 구조에 맞춰 최대 5단계의 복합형 계층관리를
                지원하며, 각 계층별로 수수료 정책을 자동 반영하여 실적 기반의 정산 업무를 효율적으로
                처리할 수 있습니다. 품(Poom)은 파트너사의 영업대행 조직을 위한 전용 관리 서비스를
                제공합니다.
              </>
            ) : (
              <>
                총판, 대리점, 딜러 등 다양한 영업 구조에 맞춰 최대 5단계의 복합형 계층관리를
                지원하며, <br /> 각 계층별로 수수료 정책을 자동 반영하여 실적 기반의 정산 업무를
                효율적으로 처리할 수 있습니다. <br />
                품(Poom)은 파트너사의 영업대행 조직을 위한 전용 관리 서비스를 제공합니다.
              </>
            )}
          </span>
        </div>

        {/* 최대 5단계 계층관리 */}
        <div className="flex flex-col gap-[16px]">
          <div className="flex flex-row gap-3 items-center">
            <img width={24} height={24} src="/assets/images/icon/stairs.png" alt="stairs" />
            <span className="text-[20px] md:text-[28px] font-normal ">최대 5단계 계층관리</span>
          </div>

          {/* 영업대행 관리 서비스 흐름 이미지 */}
          <div className="w-full max-w-full overflow-hidden min-w-0 relative">
            {isMobile && (
              <div className="pointer-events-none absolute top-3 right-10 flex justify-center z-10 bg-black/50 px-3 py-1 rounded-full w-[fit-content]">
                <span className="text-[16px] text-white">↔ 좌우로 넘겨보세요</span>
              </div>
            )}
            <div className="w-full overflow-x-auto overflow-y-hidden overscroll-x-contain md:overflow-x-hidden">
              <div className="w-[1246px] md:w-full">
                <img
                  src={"/assets/images/introduction/eg10.png"}
                  alt="eg1"
                  className="block w-full h-auto"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="flex flex-col gap-[24px] md:gap-[80px]">
        <div className="flex flex-col gap-6">
          {isMobile ? (
            <div className="flex flex-col gap-3">
              <h2 className="text-[18px] font-bold text-xl text-[#121319]">
                영업대행 관리 서비스는 <br />
                작은 조직도 대기업처럼{" "}
              </h2>
              <span className="font-normal text-[16px] text-[#4D4F58] leading-[1.5]">
                가맹점·수수료·승인을 체계적으로 관리해 {isMobile && <br />} 영업 효율을 높여주는
                기능입니다.
              </span>
            </div>
          ) : (
            <h2 className="font-bold text-display2 text-[#121319]">
              영업대행 관리 서비스는 작은 조직도 대기업처럼 <br /> 가맹점·수수료·승인을 체계적으로
              관리해 영업 효율을 높여주는 기능입니다.
            </h2>
          )}
          <span className="font-normal text-[16px] md:text-heading1_2 text-[#4D4F58] leading-[1.5]">
            {isMobile ? (
              <>
                별도의 개발 없이 품 서비스를 활용하면 작은 조직도 대기업처럼 체계적인 영업 운영이
                가능하며, {!isBr && <br />} 파트너사의 영업 경쟁력을 높이는 핵심 도구가 됩니다.
              </>
            ) : (
              <>
                {" "}
                별도의 개발 없이 품 서비스를 활용하면 작은 조직도 대기업처럼 체계적인 영업 운영이
                가능하며, 파트너사의 영업 경쟁력을 높이는 핵심 도구가 됩니다.
              </>
            )}
          </span>
        </div>

        {/* 영업대행 관리 서비스 카드 섹션 */}
        <div className="flex flex-col gap-[30px]">
          <div className="flex flex-col md:gap-[100px] gap-[80px]">
            {/* 섹션 1 */}
            <div className="flex flex-col md:grid md:grid-cols-[repeat(auto-fit,minmax(330px,1fr))] gap-3 md:gap-[30px]">
              <div
                className="flex-1 flex flex-col rounded-[24px] md:h-[524px]"
                style={{
                  //  회색 보더(기본 유지)
                  boxShadow: "inset 0 0 0 1px #DDE0E6",

                  //  그라데이션을 border 영역에만 얹기 위한 세팅
                  border: "3px solid transparent",
                  backgroundOrigin: "border-box",
                  backgroundClip: "padding-box, border-box",

                  //  안쪽은 흰색, 바깥(border)은 부분 conic 그라데이션
                  backgroundImage: `
      linear-gradient(#ffffff, #ffffff),
      conic-gradient(
        from 270deg,
        #0079FF 60deg,
        #00FF44 100deg,
 
        transparent 90deg,
        transparent 360deg
      )
    `,
                }}
              >
                <div className="flex flex-col justify-center px-[24px] py-[32px]  md:p-10 h-full">
                  <div className="flex flex-col gap-[24px] items-start w-full">
                    <img
                      src="/assets/images/introduction/support.png"
                      alt="icon1"
                      width={56}
                      height={56}
                    />

                    <div className="flex flex-col gap-5">
                      <span className="md:h-[94px] font-bold text-[18px] md:text-display3_1 break-keep">
                        복합형 계층관리 지원{" "}
                        <span className="font-normal text-[18px] md:text-display3_1 break-keep">
                          (최대 5단계)
                        </span>
                      </span>
                      <CheckRow
                        content={
                          <span className="font-normal text-[16px] md:text-[18px] text-[#4D4F58] leading-[1.5]">
                            총판, 대리점, 딜러 등 {!isMobile && <br />} 다양한 영업 구조에{" "}
                            {isMobile && <br />}
                            맞춘 {!isMobile && <br />}계층별 수수료 정책 설정 가능
                          </span>
                        }
                      />
                    </div>
                  </div>
                </div>
              </div>
              {isMobile ? (
                <MobileCard2
                  src="/assets/images/introduction/manage.png"
                  text={
                    <>
                      조직 규모와 관계없이 체계적인 영업 운영이 <br />
                      가능하며, 실적 기반의 정산 자동화 지원
                    </>
                  }
                  title="확장성 있는 영업대행 관리"
                />
              ) : (
                <div
                  className="relative flex-1 flex flex-col rounded-[24px] h-[524px] "
                  style={{
                    //  회색 보더(기본 유지)
                    boxShadow: "inset 0 0 0 1px #DDE0E6",

                    //  그라데이션을 border 영역에만 얹기 위한 세팅
                    border: "3px solid transparent",
                    backgroundOrigin: "border-box",
                    backgroundClip: "padding-box, border-box",

                    //  안쪽은 흰색, 바깥(border)은 부분 conic 그라데이션
                    backgroundImage: `
      linear-gradient(#ffffff, #ffffff),
      conic-gradient(
       from 330deg,
    #FFC300 6deg,
    #00FF44 16deg,
    #0079FF 22deg,
    transparent 65deg,
    transparent 360deg
      )
    `,
                  }}
                >
                  <div className="flex flex-col justify-center  md:p-10 h-full">
                    <div className="flex flex-col gap-6 items-start w-full">
                      <img
                        src="/assets/images/introduction/manage.png"
                        alt="icon1"
                        width={56}
                        height={56}
                      />

                      <div className="flex flex-col gap-5">
                        <span className="h-[94px] font-bold text-display3_1 ">
                          확장성 있는 <br />
                          영업대행 관리
                        </span>
                        <CheckRow
                          content={
                            <span className="font-normal text-[18px] text-[#4D4F58] leading-[1.5]">
                              조직 규모와 관계없이 <br />
                              체계적인 영업 운영이 가능하며, <br />
                              실적 기반의 정산 자동화 지원
                            </span>
                          }
                        />
                      </div>
                    </div>
                  </div>
                </div>
              )}
              {isMobile ? (
                <div
                  className="flex-1 flex flex-col rounded-[24px] md:h-[394px]"
                  style={{
                    //  회색 보더(기본 유지)
                    boxShadow: "inset 0 0 0 1px #DDE0E6",

                    //  그라데이션을 border 영역에만 얹기 위한 세팅
                    border: "3px solid transparent",
                    backgroundOrigin: "border-box",
                    backgroundClip: "padding-box, border-box",

                    //  안쪽은 흰색, 바깥(border)은 부분 conic 그라데이션
                    backgroundImage: `
    linear-gradient(#ffffff, #ffffff),
    conic-gradient(
      from 90deg,
      #00FF44 1deg,
       #0079FF 90deg,

      transparent 10deg,
      transparent 360deg
    )
  `,
                  }}
                >
                  <div className="flex flex-col p-6 items-center justify-center md:p-10 md:h-full">
                    <div className="flex flex-col gap-6 items-start w-full">
                      <img
                        src="/assets/images/introduction/saas_service.png"
                        alt="icon1"
                        width={56}
                        height={56}
                      />

                      <div className="flex flex-col gap-3 md:gap-5">
                        <span className="md:h-[94px] font-bold text-[18px] md:text-display3_1 ">
                          영업대행 전용 SaaS 서비스 제공
                          <br />
                          <span className="font-normal text-[18px]">(웹·앱 지원)</span>
                        </span>
                        <CheckRow
                          content={
                            <span className="font-normal text-[16px] md:text-[18px] text-[#4D4F58] leading-[1.5]">
                              영업대행이 웹과 모바일 앱을 통해 직접 가맹점 등록, 승인 요청,
                              매출·입금·수수료 조회까지 한 번에 처리할 수 있는 전용 관리 서비스
                            </span>
                          }
                        />
                      </div>
                    </div>
                  </div>
                </div>
              ) : (
                <div
                  className="flex-1 flex flex-col rounded-[24px] h-[524px]"
                  style={{
                    //  회색 보더(기본 유지)
                    boxShadow: "inset 0 0 0 1px #DDE0E6",

                    //  그라데이션을 border 영역에만 얹기 위한 세팅
                    border: "3px solid transparent",
                    backgroundOrigin: "border-box",
                    backgroundClip: "padding-box, border-box",

                    //  안쪽은 흰색, 바깥(border)은 부분 conic 그라데이션
                    backgroundImage: `
      linear-gradient(#ffffff, #ffffff),
      conic-gradient(
        from 360deg,
        #0079FF 0deg,
        #00FF44 90deg,
        #FFC300 110deg,
        transparent 90deg,
        transparent 360deg
      )
    `,
                  }}
                >
                  <div className="flex flex-col p-6 items-center justify-center md:p-10  md:h-[524px] ">
                    <div className="flex flex-col gap-6 items-start w-full">
                      <img
                        src="/assets/images/introduction/saas_service.png"
                        alt="icon1"
                        width={56}
                        height={56}
                      />

                      <div className="flex flex-col gap-3 md:gap-5">
                        <span className="md:h-[94px] font-bold text-[20px] md:text-display3_1 ">
                          영업대행 전용 {!isMobile ? <br /> : ""} 서비스 제공
                          {isMobile ? <br /> : ""}
                          {isMobile ? <> (웹·앱 지원)</> : ""}
                        </span>
                        <CheckRow
                          content={
                            <span className="font-normal text-[14px] md:text-[18px] text-[#4D4F58] break-keep leading-[1.5]">
                              영업대행이 웹과 모바일 앱을 통해 직접 가맹점 등록, 승인 요청,
                              매출·입금 ·수수료 조회까지 한 번에 처리할 수 있는 전용 관리 서비스
                            </span>
                          }
                        />
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>

            <div className="flex flex-col md:gap-[80px] gap-[24px]">
              <div className="flex flex-col md:gap-6 gap-3">
                <h1 className="font-bold md:text-display2 text-[18px]">
                  영업대행전용 서비스 기능 소개
                </h1>
                <span className="font-normal md:text-heading1_2 text-[#4D4F58] text-[16px] leading-[1.5]">
                  개별 영업 담당자를 위한 모바일 환경은 물론, 대행사 조직 전체를 유연하게 운영할 수
                  있는 전용 관리자(Admin) 기능을 제공합니다
                </span>
              </div>

              <div className="flex flex-col md:grid md:grid-cols-[repeat(auto-fit,minmax(360px,1fr))] gap-[12px] ">
                <div
                  className="flex-1 flex flex-col rounded-[24px] md:h-[524px]"
                  style={{
                    //  회색 보더(기본 유지)
                    boxShadow: "inset 0 0 0 1px #DDE0E6",
                    //  모바일/PC 그라데이션 분기
                    ...(isMobile
                      ? {
                          //  모바일: 기존 conic-gradient
                          border: "3px solid transparent",
                          backgroundOrigin: "border-box",
                          backgroundClip: "padding-box, border-box",
                          backgroundImage: `
      linear-gradient(#ffffff, #ffffff),
      conic-gradient(
        from 270deg,
        #0079FF 60deg,
        #00FF44 100deg,
 
        transparent 90deg,
        transparent 360deg
      )
    `,
                        }
                      : {
                          //  PC: 요청하신 conic-gradient 각도
                          border: "3px solid transparent",
                          backgroundOrigin: "border-box",
                          backgroundClip: "padding-box, border-box",
                          backgroundImage: `
      linear-gradient(#ffffff, #ffffff),
      conic-gradient(
        from 180deg,
        #0079FF 30deg,
        #00FF44 90deg,
        #FFC300 110deg,
        transparent 90deg,
        transparent 360deg
      )
    `,
                        }),
                  }}
                >
                  <div className="flex flex-col justify-center px-[24px] py-[32px]  md:p-10 h-full">
                    <div className="flex flex-col gap-[24px] items-start w-full">
                      <img
                        src="/assets/images/introduction/search.png"
                        alt="icon1"
                        width={56}
                        height={56}
                      />

                      <div className="flex flex-col gap-5">
                        <span className="md:h-[94px] font-bold text-[18px] md:text-display3_1 break-keep">
                          {isMobile ? (
                            "수수료 및 실적 실시간 조회까지"
                          ) : (
                            <>
                              수수료 및 실적
                              <br />
                              실시간 조회
                            </>
                          )}
                        </span>
                        <CheckRow
                          content={
                            <span className="font-normal text-[16px] md:text-[18px] text-[#4D4F58] leading-[1.5]">
                              {isMobile ? (
                                <>
                                  거래에 따른 세금처리 기능을
                                  <br />
                                  자동화하여 회계 편의성 제공
                                </>
                              ) : (
                                <>
                                  영업 실적에 따른 수수료를
                                  <br />
                                  자동 계산하여 투명하고 정확한
                                  <br />
                                  정산 환경 제공
                                </>
                              )}
                            </span>
                          }
                        />
                      </div>
                    </div>
                  </div>
                </div>

                {isMobile ? (
                  <MobileCard2
                    title="가맹점 등록/요청/승인 기능"
                    src="/assets/images/introduction/enroll_approve.png"
                    text={[
                      <span className="font-normal text-[16px] md:text-[18px] text-[#4D4F58]">
                        영업대행이 직접 가맹점을 등록하고 <br />
                        승인 요청까지 처리 가능
                      </span>,
                    ]}
                  />
                ) : (
                  <div
                    className="flex-1 flex flex-col rounded-[24px] h-[524px] relative bg-white"
                    style={{
                      // 기본 회색 보더
                      boxShadow: "inset 0 0 0 1px #DDE0E6",
                    }}
                  >
                    {/* 하단 그라데이션 바 */}
                    <div
                      className="
      absolute
      left-[12%]
      right-[12%]
      bottom-0
      h-[3px]
      rounded-full
    "
                      style={{
                        background: "linear-gradient(90deg, #0079FF 0%, #00FF44 50%, #0079FF 100%)",
                      }}
                    />
                    <div className="flex flex-col justify-center  md:p-10 h-full">
                      <div className="flex flex-col gap-6 items-start w-full">
                        <img
                          src="/assets/images/introduction/enroll_approve.png"
                          alt="icon1"
                          width={56}
                          height={56}
                        />

                        <div className="flex flex-col gap-5">
                          <span className="h-[94px] font-bold text-display3_1 ">
                            가맹점 <br />
                            등록/요청/승인 기능
                          </span>
                          <CheckRow
                            content={
                              <span className="font-normal text-[18px] text-[#4D4F58]">
                                영업대행이 직접 가맹점을 등록하고 <br />
                                승인 요청까지 처리 가능
                              </span>
                            }
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                )}
                {isMobile ? (
                  <div
                    className="flex-1 flex flex-col rounded-[24px] md:h-[394px]"
                    style={{
                      //  회색 보더(기본 유지)
                      boxShadow: "inset 0 0 0 1px #DDE0E6",

                      //  그라데이션을 border 영역에만 얹기 위한 세팅
                      border: "3px solid transparent",
                      backgroundOrigin: "border-box",
                      backgroundClip: "padding-box, border-box",

                      //  안쪽은 흰색, 바깥(border)은 부분 conic 그라데이션
                      backgroundImage: `
      linear-gradient(#ffffff, #ffffff),
      conic-gradient(
        from 90deg,
        #00FF44 1deg,
         #0079FF 90deg,
 
        transparent 10deg,
        transparent 360deg
      )
    `,
                    }}
                  >
                    <div className="flex flex-col p-6 items-center justify-center md:p-10 md:h-full">
                      <div className="flex flex-col gap-6 items-start w-full">
                        <img
                          src="/assets/images/introduction/check_deposit.png"
                          alt="icon1"
                          width={56}
                          height={56}
                        />

                        <div className="flex flex-col gap-3 md:gap-5">
                          <span className="md:h-[94px] font-bold text-[18px] md:text-display3_1 ">
                            가맹점 매출입금내역조회
                          </span>
                          <CheckRow
                            content={
                              <span className="font-normal text-[16px] md:text-[18px] text-[#4D4F58] leading-[1.5]">
                                담당 가맹점의 매출과 실적, <br />
                                입금내역을 실시간으로 확인 가능
                              </span>
                            }
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                ) : (
                  <div
                    className="flex-1 flex flex-col rounded-[24px] h-[524px]"
                    style={{
                      //  회색 보더(기본 유지)
                      boxShadow: "inset 0 0 0 1px #DDE0E6",

                      //  그라데이션을 border 영역에만 얹기 위한 세팅
                      border: "3px solid transparent",
                      backgroundOrigin: "border-box",
                      backgroundClip: "padding-box, border-box",

                      //  안쪽은 흰색, 바깥(border)은 부분 conic 그라데이션
                      backgroundImage: `
      linear-gradient(#ffffff, #ffffff),
      conic-gradient(
        from 90deg,
        #0079FF 60deg,
        #00FF44 100deg,
        #FFC300 110deg,
        transparent 90deg,
        transparent 360deg
      )
    `,
                    }}
                  >
                    <div className="flex flex-col justify-center md:p-10 h-full">
                      <div className="flex flex-col gap-6 items-start w-full">
                        <img
                          src="/assets/images/introduction/check_deposit.png"
                          alt="icon1"
                          width={56}
                          height={56}
                        />

                        <div className="flex flex-col gap-5">
                          <span className="h-[94px] font-bold text-display3_1 ">
                            가맹점 매출
                            <br />
                            입금내역 조회
                          </span>
                          <CheckRow
                            content={
                              <span className="font-normal text-[18px] text-[#4D4F58]">
                                담당 가맹점의 매출과 실적,
                                <br />
                                입금내역을 실시간으로 확인 가능
                              </span>
                            }
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
